export default {
  key: 'Ab',
  suffix: '6',
  positions: [{
    frets: '1313',
    fingers: '1324'
  }, {
    frets: '5546',
    fingers: '2314'
  }, {
    frets: '8888',
    fingers: '1111',
    barres: 8,
    capo: true
  }, {
    frets: 'acbb',
    fingers: '1423'
  }]
};